import { ListSubheader, styled } from "@mui/material";
import { FC } from "react";
import { COLORS } from "../../constants/colors";

const StyledListSubheader = styled(ListSubheader)`
  color: ${COLORS.TEXT_SECONDARY};
  text-transform: uppercase;
  font-weight: bold;
  white-space: nowrap;
  position: relative;
  margin-left: 6px;
  line-height: 30px;
  overflow: hidden;
`;

const MenuSubheader: FC<{ text: string }> = ({ text }) => (
  <StyledListSubheader disableSticky>{text}</StyledListSubheader>
);

export { MenuSubheader };
